<template>
  <!-- eslint-disable max-len -->
  <div class="route-wrapper" v-if="!showInvalidSection">
    <div
      class="spotlight-card text-grey"
      style="justify-content: flex-start;"
      v-if="onSuccessfulReset"
    >
      <h2 style="color: #48D16C;">
        {{ $t("common.change-password-success") }}
      </h2>
      <span
        v-html="$t('common.login-here', { login: url, settings: settingsUrl })"
      ></span>
    </div>
    <div class="spotlight-card" v-if="!onSuccessfulReset">
      <h2 class="text-grey">{{ $t("common.new-password") }}</h2>
      <form @submit.prevent="onSubmit">
        <div class="form-item">
          <label for="password" class="text-grey">{{
            $t("common.your-new-password")
          }}</label>
          <input
            id="password"
            class="text-grey"
            type="password"
            placeholder="******"
            autocomplete="off"
            v-model.trim="$v.password.$model"
          />
          <p class="validation-msg" v-visible="$v.password.$error">
            {{ $t("common.password-invalid-error") }}
          </p>
        </div>
        <div class="form-item">
          <label for="repeatPassword" class="text-grey">{{
            $t("common.repeat-password")
          }}</label>
          <input
            id="repeatPassword"
            class="text-grey"
            type="password"
            placeholder="******"
            autocomplete="off"
            v-model.trim="$v.repeatPassword.$model"
          />
          <p
            class="validation-msg"
            v-visible="!$v.repeatPassword.sameAsPassword"
          >
            {{ $t("common.repeat-password-description") }}
          </p>
        </div>
        <div class="form-item">
          <button
            type="submit"
            class="text-white primary-bg-color"
            :disabled="disableButton"
            :class="{ loading: isProcessing }"
          >
            {{ $t("common.submit-new-password") }}
            <svg
              viewBox="0 0 1024 1024"
              fill="currentColor"
              width="1em"
              height="1em"
              class="spin"
            >
              <path
                d="M988 548c-19.9 0-36-16.1-36-36 0-59.4-11.6-117-34.6-171.3a440.45 440.45 0 0 0-94.3-139.9 437.71 437.71 0 0 0-139.9-94.3C629 83.6 571.4 72 512 72c-19.9 0-36-16.1-36-36s16.1-36 36-36c69.1 0 136.2 13.5 199.3 40.3C772.3 66 827 103 874 150c47 47 83.9 101.8 109.7 162.7 26.7 63.1 40.2 130.2 40.2 199.3.1 19.9-16 36-35.9 36z"
              />
            </svg>
          </button>
        </div>
        <div class="form-item">
          <p
            class="info text-grey"
            v-html="$t('common.repeat-password-info')"
          ></p>
        </div>
      </form>
    </div>
  </div>
  <InvalidPassword v-else />
</template>
<script>
import Vue from "vue";
import { validationMixin } from "vuelidate";
import { minLength, required, sameAs } from "vuelidate/lib/validators";
import ConnectApi from "../api/connect.api";
import { getQueryParam } from "../shared/utilities";
import InvalidPassword from "./InvalidPassword.vue";

export default {
  name: "newPassword",
  components: { InvalidPassword },
  mixins: [validationMixin],
  validations: {
    password: {
      required,
      minLength: minLength(8),
    },
    repeatPassword: {
      required,
      sameAsPassword: sameAs("password"),
    },
  },
  data() {
    return {
      url: !getQueryParam("ot")
        ? window.__config__.loginUrl
        : decodeURIComponent(getQueryParam("ot")),
      settingsUrl: window.__config__.settingsUrl,
      onSuccessfulReset: false,
      password: "",
      repeatPassword: "",
      isProcessing: false,
      disableButton: false,
      showInvalidSection: false,
    };
  },
  methods: {
    onSubmit() {
      this.showInvalidSection = false;
      this.$v.$touch();
      if (!this.$v.$invalid) {
        this.disableButton = true;
        this.isProcessing = true;
        ConnectApi.setNewPassword(this.password)
          .then(() => {
            this.isProcessing = false;
            this.disableButton = false;
            this.onSuccessfulReset = true;
          })
          .catch((err) => {
            Vue.rollbar.error("[portal]: Failed to set new password", err);
            this.isProcessing = false;
            this.disableButton = false;
            this.onSuccessfulReset = false;

            if (err.response.status === 401) this.showInvalidSection = true;
            else
              this.$toaster.error(
                this.$i18n.messages[this.$i18n.locale].common[
                  "reset-password-error"
                ]
              );
          });
      }
    },
  },
};
</script>
